import { addToChainBefore } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    LoadProducts,
} from "@insite/client-framework/Store/Components/CompareProductsDrawer/Handlers/LoadProductsToCompare";

export const XngAddCustomExpand: any = (props: any) => {
    const additionalExpands = "getbadges,getstyledchildrencount,properties";
    props.apiParameter = {
        ...props.apiParameter,
        additionalExpands,
    };
};

addToChainBefore(chain, LoadProducts, XngAddCustomExpand);
